<dx-data-grid #grid>
   <dxo-header-filter [visible]="true"></dxo-header-filter>

   <dxi-column caption="Vedi" width="85" cellTemplate="bntVediTemplate" alignment="center"
               [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"></dxi-column>
   <div *dxTemplate="let item of 'bntVediTemplate'">
      <a class="btn-tbl icon-modifica" [routerLink]="[item.data.id]" >
<!--         <i class="fa-solid fa-pen"></i>-->
      </a>
   </div>

   <dxi-column dataField="display_id" alignment="center" [allowHeaderFiltering]="false" [allowFiltering]="true" [caption]="isAmmanco ? 'Numero Ammanco' : 'Numero Esubero'" width="170"></dxi-column>
   <dxi-column dataField="stato" caption="Stato" width="120" alignment="center" [allowHeaderFiltering]="true" [allowFiltering]="true" cellTemplate="statoTemplate" >
      <dxo-header-filter
         [dataSource]="headerFilterStatoData">
      </dxo-header-filter>
   </dxi-column>
   <div *dxTemplate="let item of 'statoTemplate'">
      <span *ngIf="item.data.stato == 'bozza'" class="badgered">{{item.data.stato}}</span>
      <span *ngIf="item.data.stato == 'completo'" class="badgegreen">{{item.data.stato}}</span>
   </div>
<!--   <dxi-column dataField="data_creazione" dataType="startDate" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Data"></dxi-column>-->
   <dxi-column dataField="data" dataType="date" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false" alignment="center" caption="Data creazione" width="150"></dxi-column>
   <dxi-column dataField="ora" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false" alignment="center" caption="Ora creazione" cellTemplate="oraTemplate" width="110"></dxi-column>
   <div *dxTemplate="let cellInfo of 'oraTemplate'">
      {{moment(cellInfo.data.ora, 'HH:mm:ss').format('HH:mm')}}
   </div>
   <dxi-column dataField="causale" caption="Causale" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
   <dxi-column dataField="qta" caption="Quantità" width="110" alignment="center" [allowHeaderFiltering]="false" [allowFiltering]="true" [allowSearch]="false"></dxi-column>
   <dxi-column dataField="note" caption="Note" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
   <dxi-column cellTemplate="eliminaTemplate" caption="Elimina" alignment="center" width="100" [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"></dxi-column>
   <div *dxTemplate="let item of 'eliminaTemplate'">
      <button class="btn-tbl-trash"
              (click)="clickEliminaRettifica(item)">
         <i class="fa-light fa-trash-can"></i>
      </button>
   </div>
</dx-data-grid>